import axios from "axios";
import { registrationNumberRegex } from "./validate";

export const getRegexData = async () => {
  try {
    const res = await axios(`${process.env.HOST_URL}/api/falcon/regexService/`);
    const data = res.data;
    return data;
  } catch (e) {
    return {
      registration_number: registrationNumberRegex
    };
  }
};
